import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeEvery } from 'redux-saga/effects';
import { StoreSettingDetailGetAllRequestPayload, StoreSettingDetailGetAllResponse } from './models';
import storeSettingDetailService from './storeSettingDetailService';
import { storeSettingDetailActions } from './storeSettingDetailSlice';

function* getData(action: PayloadAction<StoreSettingDetailGetAllRequestPayload>) {
  try {
    const response: CommonResponse<StoreSettingDetailGetAllResponse> = yield call(
      storeSettingDetailService.getAll,
      action.payload
    );
    yield put(storeSettingDetailActions.fetchDataSuccess(response.data));
  } catch (e) {
    yield put(storeSettingDetailActions.fetchDataFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* storeSettingDetailSaga() {
  yield takeEvery(storeSettingDetailActions.fetchData.type, getData);
}
